import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AuditService,
  HypermediaService,
  IngredientChoicesType,
  OrderableItem,
  OrderableItemService,
  OrderableSpecialStepAlternativeItem,
  OrderedItemService,
} from 'ngx-web-api';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ItemEditorService } from '../../../core/services/item-editor.service';

import { SpecialWizardStep } from '../../../domain/special-wizard-step';

@Component({
  selector: 'fts-item-choice',
  templateUrl: './item-choice.component.html',
  styleUrls: ['./item-choice.component.scss'],
})
export class ItemChoiceComponent {
  @Input()
  stepItem: OrderableSpecialStepAlternativeItem;
  @Input()
  currentStep: SpecialWizardStep;

  @Output()
  itemSelected: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  sizeSelected: EventEmitter<string> = new EventEmitter<string>();

  customizeItemLoadingSubscription: Subscription;
  selectItemLoadingSubscription: Subscription;

  constructor(
    public orderableItemService: OrderableItemService,
    private orderedItemService: OrderedItemService,
    private hypermediaService: HypermediaService,
    private itemEditorService: ItemEditorService,
    private auditService: AuditService
  ) {}

  customizeItem() {
    this.selectItem(true);
  }

  selectItem(isCustomizing?: boolean) {
    if (isCustomizing && this.currentStep.selectedOrderableItem) {
      this.itemSelected.emit(isCustomizing);
    } else {
      const sizePrices = this.stepItem.availableSizePrices;
      if (sizePrices.length === 1) {
        this.stepItem.selectedSize = sizePrices[0].size;
      }

      const loadingSubscription = this.resolveOrderableItem().subscribe(orderableItem => {
        if (this.stepItem.selectedSize) {
          const selectedOrderedItem = this.orderedItemService.createOrderedItem(orderableItem, this.stepItem.selectedSize);
          const orderedItemSizePrice = orderableItem.getSizePrice(selectedOrderedItem.size);
          selectedOrderedItem.noticePeriod = orderedItemSizePrice.noticePeriod;

          if (isCustomizing) {
            this.orderedItemService.validateItem(
              selectedOrderedItem,
              orderableItem,
              this.itemEditorService.getChoicesLayout(orderableItem) === IngredientChoicesType.Steps
            );
          }

          this.currentStep.selectedOrderableItem = orderableItem;
          this.currentStep.selectedOrderedItem = selectedOrderedItem;
          this.itemSelected.emit(isCustomizing);
          if (isCustomizing) {
            this.auditService.createAudit(() => `Customize "${orderableItem.name}" button pressed`);
          }
          this.auditService.createAudit(() => `Selected ${selectedOrderedItem.size} ${orderableItem.name}`);
        }
      });

      if (isCustomizing) {
        this.customizeItemLoadingSubscription = loadingSubscription;
      } else {
        this.selectItemLoadingSubscription = loadingSubscription;
      }
    }
  }

  removeItem() {
    const selectedOrderableItem = this.currentStep.selectedOrderableItem;
    const selectedOrderedItem = this.currentStep.selectedOrderedItem;
    this.currentStep.selectedOrderableItem = null;
    this.currentStep.selectedOrderedItem = null;
    this.stepItem.selectedSize = undefined;

    if (selectedOrderableItem && selectedOrderedItem) {
      this.auditService.createAudit(() => `Removed ${selectedOrderedItem.size} ${selectedOrderableItem.name}`);
    }
  }

  get isCustomizeDisabled(): boolean {
    const hasSize = this.stepItem.availableSizePrices?.length > 0;
    const hasMultipleSizes = this.stepItem.availableSizePrices?.length > 1;
    const sizeMissing = hasMultipleSizes && this.stepItem.selectedSize === undefined;
    const alreadySelected = this.currentStep?.selectedOrderableItem && !this.currentStep?.isSelectedAlternativeItem(this.stepItem);
    return !hasSize || sizeMissing || alreadySelected;
  }

  get isOrderDisabled(): boolean {
    const hasSize = this.stepItem.availableSizePrices?.length > 0;
    const hasMultipleSizes = this.stepItem.availableSizePrices?.length > 1;
    const sizeMissing = hasMultipleSizes && this.stepItem.selectedSize === undefined;
    const alreadySelected = this.currentStep?.selectedOrderableItem && !this.currentStep?.isSelectedAlternativeItem(this.stepItem);
    return !hasSize || sizeMissing || alreadySelected;
  }

  private resolveOrderableItem(): Observable<OrderableItem> {
    return this.hypermediaService.get(this.stepItem.links, 'orderableItem').pipe(map(json => new OrderableItem().deserialize(json)));
  }
}
